var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExpressSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H41C42.6569 0 44 1.34315 44 3V27C44 28.6569 42.6569 30 41 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "#016FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54712 22.6893V15.9973H15.8286L16.6099 16.9883L17.4169 15.9973H43.8471V22.2278C43.8471 22.2278 43.1559 22.6826 42.3565 22.6893H27.7216L26.8408 21.6344V22.6893H23.9544V20.8886C23.9544 20.8886 23.5602 21.1399 22.7078 21.1399H21.7253V22.6893H17.3552L16.5751 21.677L15.783 22.6893H8.54712Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0439453 10.9536L1.68596 7.22852H4.52565L5.45751 9.31516V7.22852H8.98751L9.54225 8.73668L10.08 7.22852H25.9261V7.98672C25.9261 7.98672 26.7591 7.22852 28.1281 7.22852L33.2695 7.246L34.1853 9.30534V7.22852H37.1394L37.9525 8.41144V7.22852H40.9336V13.9205H37.9525L37.1733 12.7337V13.9205H32.8331L32.3966 12.8656H31.2298L30.8004 13.9205H27.8571C26.6791 13.9205 25.9261 13.1778 25.9261 13.1778V13.9205H21.4882L20.6074 12.8656V13.9205H4.10497L3.6688 12.8656H2.50572L2.07264 13.9205H0.0439453L0.0439453 10.9536Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0523682 13.0642L2.26709 8.05347H3.94612L6.15872 13.0642H4.68507L4.27854 12.0608H1.90291L1.49426 13.0642H0.0523682ZM3.81059 10.9731L3.08647 9.21971L2.36023 10.9731H3.81059Z",
    fill: "#016FD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31116 13.0635V8.05273L8.36017 8.06014L9.55195 11.2908L10.7152 8.05273H12.7478V13.0635H11.4605V9.37135L10.0959 13.0635H8.96689L7.59849 9.37135V13.0635H6.31116Z",
    fill: "#016FD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6287 13.0635V8.05273H17.8294V9.17356H14.9295V10.0307H17.7617V11.0856H14.9295V11.9756H17.8294V13.0635H13.6287Z",
    fill: "#016FD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5747 13.0642V8.05347H21.4394C22.3887 8.05347 23.2392 8.62464 23.2392 9.67908C23.2392 10.5805 22.5221 11.1611 21.8269 11.2182L23.5208 13.0642H21.9476L20.4041 11.2841H19.862V13.0642H18.5747ZM21.3336 9.17434H19.8621V10.2292H21.3527C21.6107 10.2292 21.9434 10.0347 21.9434 9.70178C21.9434 9.44303 21.6866 9.17434 21.3336 9.17434Z",
    fill: "#016FD0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0792 13.0635H23.7648V8.05273H25.0792V13.0635Z",
    fill: "#016FD0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1959 13.0635H27.9122C26.5394 13.0635 25.7059 12.0111 25.7059 10.5787C25.7059 9.11098 26.5301 8.05273 28.2637 8.05273H29.6865V9.23949H28.2116C27.5079 9.23949 27.0102 9.77391 27.0102 10.5911C27.0102 11.5615 27.5793 11.969 28.3992 11.969H28.7379L28.1959 13.0635Z",
    fill: "#016FD0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7823 13.0642L30.9971 8.05347H32.6761L34.8887 13.0642H33.415L33.0085 12.0608H30.6329L30.2242 13.0642H28.7823ZM32.5406 10.9731L31.8165 9.21971L31.0902 10.9731H32.5406Z",
    fill: "#016FD0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0391 13.0635V8.05273H36.6758L38.7655 11.2009V8.05273H40.0529V13.0635H38.4691L36.3264 9.83287V13.0635H35.0391Z",
    fill: "#016FD0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42786 21.8323V16.8215H13.6286V17.9424H10.7287V18.7995H13.5609V19.8544H10.7287V20.7444H13.6286V21.8323H9.42786Z",
    fill: "#016FD0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0116 21.8323V16.8215H34.2124V17.9424H31.3125V18.7995H34.1311V19.8544H31.3125V20.7444H34.2124V21.8323H30.0116Z",
    fill: "#016FD0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7917 21.8323L15.8371 19.3578L13.743 16.8215H15.3649L16.612 18.3895L17.8633 16.8215H19.4217L17.3552 19.3269L19.4043 21.8323H17.7827L16.5718 20.2891L15.3903 21.8323H13.7917Z",
    fill: "#016FD0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5573 21.833V16.8223H22.4008C23.5676 16.8223 24.2492 17.554 24.2492 18.5076C24.2492 19.6588 23.3801 20.2507 22.2335 20.2507H20.8785V21.833H19.5573ZM22.3055 17.9555H20.8784V19.1093H22.3013C22.6772 19.1093 22.9407 18.8668 22.9407 18.5324C22.9407 18.1764 22.6759 17.9555 22.3055 17.9555Z",
    fill: "#016FD0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8081 21.8323V16.8215H27.6728C28.6221 16.8215 29.4726 17.3927 29.4726 18.4471C29.4726 19.3485 28.7555 19.9291 28.0603 19.9862L29.7542 21.8323H28.181L26.6375 20.0521H26.0954V21.8323H24.8081ZM27.567 17.9423H26.0955V18.9972H27.5861C27.8441 18.9972 28.1768 18.8026 28.1768 18.4697C28.1768 18.211 27.92 17.9423 27.567 17.9423Z",
    fill: "#016FD0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8086 21.8323V20.7444H37.385C37.7662 20.7444 37.9312 20.544 37.9312 20.3241C37.9312 20.1135 37.7667 19.9005 37.385 19.9005H36.2207C35.2087 19.9005 34.6451 19.3005 34.6451 18.3998C34.6451 17.5963 35.1613 16.8215 36.6651 16.8215H39.172L38.6299 17.949H36.4618C36.0474 17.949 35.9198 18.1606 35.9198 18.3627C35.9198 18.5704 36.0774 18.7995 36.394 18.7995H37.6136C38.7417 18.7995 39.2313 19.4221 39.2313 20.2376C39.2313 21.1143 38.6858 21.8323 37.5522 21.8323H34.8086Z",
    fill: "#016FD0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5335 21.8323V20.7444H42.1098C42.491 20.7444 42.6561 20.544 42.6561 20.3241C42.6561 20.1135 42.4915 19.9005 42.1098 19.9005H40.9456C39.9336 19.9005 39.37 19.3005 39.37 18.3998C39.37 17.5963 39.8861 16.8215 41.3899 16.8215H43.8968L43.3548 17.949H41.1867C40.7722 17.949 40.6446 18.1606 40.6446 18.3627C40.6446 18.5704 40.8023 18.7995 41.1189 18.7995H42.3385C43.4666 18.7995 43.9561 19.4221 43.9561 20.2376C43.9561 21.1143 43.4106 21.8323 42.2771 21.8323H39.5335Z",
    fill: "#016FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpressSm);
export default __webpack_public_path__ + "static/media/AmericanExpress_sm.6e63f47f8fcb4efe346aec466ad03596.svg";
export { ForwardRef as ReactComponent };